import { fieldsConfig } from './configFields';

const orderSummaryOptions = [
  {
    property: 'nametag',
    label: 'Name for roster'
  },
  {
    property: 'email',
    label: 'Email'
  },
  {
    property: 'phone',
    label: 'Phone'
  },
  {
    property: 'address',
    label: 'Address'
  },
  {
    property: 'age',
    label: 'Age',
    mapping: fieldsConfig['age'].options
  },
  {
    property: 'share',
    label: 'Include on roster',
    defaultValue: 'do not share'
  },
  {
    property: 'allergies',
    label: 'Allergies'
  },
  {
    property: 'carpool',
    label: 'Transportation',
    mapping: fieldsConfig['carpool'].options
  },
  {
    property: 'volunteer',
    label: 'Volunteering',
    mapping: fieldsConfig['volunteer'].options
  },
  {
    property: 'housing',
    label: 'Housing'
  },
  {
    property: 'roommate',
    label: 'Roommate'
  },
  {
    property: 'comments',
    label: 'Comments'
  }
];

export default { orderSummaryOptions };